import { render, staticRenderFns } from "./AppCardCode.vue?vue&type=template&id=33f9aef9&scoped=true&"
import script from "./AppCardCode.vue?vue&type=script&lang=js&"
export * from "./AppCardCode.vue?vue&type=script&lang=js&"
import style0 from "./AppCardCode.vue?vue&type=style&index=0&id=33f9aef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9aef9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDivider,VExpandTransition,VFadeTransition,VIcon,VSlideXReverseTransition,VSnackbar,VSpacer})
